import { render, staticRenderFns } from "./user-register.vue?vue&type=template&id=3f6742da&scoped=true&"
import script from "./user-register.vue?vue&type=script&lang=js&"
export * from "./user-register.vue?vue&type=script&lang=js&"
import style0 from "./user-register.vue?vue&type=style&index=0&id=3f6742da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6742da",
  null
  
)

export default component.exports